<template>
  <div class="crops d-flex" v-if="eventCrops">
    <div class="crop" :class="{ 'crop-big': isBig }" v-for="(crop, index) in crops" :key="index">
      <span :class="['icon', crop.icon]"></span>
    </div>
  </div>
</template>

<script>
import EventMixin from '../mixins/EventMixin';

export default {
  name: 'EventCrops',
  data: () => ({
    crops: [],
  }),
  props: {
    eventCrops: String,
    isBig: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  mixins: [EventMixin],
  mounted() {
    this.getCrops(this.eventCrops);
  },
};
</script>

<style scoped lang="scss">
.crops {
  .crop {
    width: 40px;
    height: 40px;
    background-color: #e3e2dd;
    margin-right: 0.625rem;
    &:last-child {
      margin-right: 0;
    }
    &-big {
      width: 60px;
      height: 60px;
    }
    .icon {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
